module.exports = __webpack_public_path__ + "static/media/application_3.a865b8ed.png";